<div class="subscription-plan-card-component">
    <mat-card class="subscription-card" appearance="outlined">
        <mat-card-header class="d-flex flex-column align-items-center">
            <div class="discount-banner" *ngIf="discountPercentage && discountPercentage.value">
                {{ `${discountPercentage.text} OFF` }}
            </div>
            <mat-card-title class="subscription-title" [title]="getCardInfo(subscriptionPlan).PlanLabel">{{
                getCardInfo(subscriptionPlan).PlanLabel}}</mat-card-title>
            <mat-card-subtitle class="price-container"
                [title]="getCardInfo(subscriptionPlan).Price + getCardInfo(subscriptionPlan).PriceLabel">
                <span class="subscription-price">
                    {{getCardInfo(subscriptionPlan).Price}}
                </span>
                <span class="subscription-price-label">
                    {{getCardInfo(subscriptionPlan).PriceLabel}}
                </span>
            </mat-card-subtitle>
            <mat-card-subtitle class="price-container"
                [style.visibility]="getCardInfo(subscriptionPlan).showFinalAmountWithoutDiscount ? 'visible' : 'hidden'"
                [title]="getCardInfo(subscriptionPlan).FinalPriceWithoutDiscount + getCardInfo(subscriptionPlan).PriceLabel">
                <span class="subscription-price-without-discount">
                    {{getCardInfo(subscriptionPlan).FinalPriceWithoutDiscount}}
                </span>
                <span class="subscription-price-without-discount-label"
                    *ngIf="getCardInfo(subscriptionPlan).PriceLabel !='(One-Time)'">
                    {{getCardInfo(subscriptionPlan).PriceLabel}}
                </span>
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content class="card-content">
            <ul class="features-list">
                <ng-container *ngFor="let feature of getCardInfo(subscriptionPlan).Features">
                    <li class="feature-item" [title]="feature.FeatureDescription">
                        <span class="tick-icon"></span>
                        <span class="feature-text">{{ feature.FeatureName }}</span>
                    </li>
                </ng-container>
            </ul>
        </mat-card-content>
        <mat-card-actions *ngIf="isBlockedByTrial; else defaultActions">
            <button mat-button disabled title="Free Trial Active">Free Trial Active</button>
            <p class="plan-action" [title]="trialMessage">{{ trialMessage }}</p>
        </mat-card-actions>
        <ng-template #defaultActions>
            <!-- The organization manages this user's plan, so there is nothing to buy or change -->
            <mat-card-actions *ngIf="!managedByOrganization">
                <button [style.visibility]="getCardInfo(subscriptionPlan).showButton ? 'visible' : 'hidden'" mat-button
                    [disabled]="(hasPendingOrder && getCardInfo(subscriptionPlan).showButton) || getCardInfo(subscriptionPlan).ButtonLabel === PlanButtonLabel.Active"
                    [title]="(hasPendingOrder && getCardInfo(subscriptionPlan).showButton) ? PlanButtonLabel.OrderPending : getCardInfo(subscriptionPlan).ButtonLabel"
                    (click)="onSubscriptionPlanClick(subscriptionPlan, getCardInfo(subscriptionPlan).ButtonLabel)">
                    {{ (hasPendingOrder && getCardInfo(subscriptionPlan).showButton) ? PlanButtonLabel.OrderPending :
                    getCardInfo(subscriptionPlan).ButtonLabel }}
                </button>
                <p class="plan-action"
                    [style.visibility]="((hasPendingOrder && getCardInfo(subscriptionPlan).showButton) || getCardInfo(subscriptionPlan).PlanAction) ? 'visible' : 'hidden'">
                    {{ (hasPendingOrder && getCardInfo(subscriptionPlan).showButton) ?
                    getPlanAction(PlanButtonLabel.OrderPending) :
                    getCardInfo(subscriptionPlan).PlanAction }}
                </p>
            </mat-card-actions>
        </ng-template>
    </mat-card>
</div>